import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { REACT_QUERY_PERSIST_KEY } from '@/react-query/constants';

export const useClearQueryCache = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.clear();
    try {
      window.localStorage.removeItem(REACT_QUERY_PERSIST_KEY);
    } catch {
      // localStorage may be unavailable (e.g., privacy mode)
    }
  }, [queryClient]);
};
